import FSliderComponent from './slider-fullscreen';

export default FSliderComponent;